import {updateAllAlertSettings} from '../../../api/settings/alert_alarm';
import {ProcessAlertRange, relativeValue} from './constants';
import {Dispatch, FC} from 'react';
import {useSnackbarHook} from '../../../hooks/useSnackbar';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import {useTranslation} from 'react-i18next';

interface AlertSettingSwitchersProps {
  alertType: string,
  isSwitching: boolean,
  setIsSwitching: Dispatch<boolean>,
  isRelative: boolean,
  setIsRelative: Dispatch<boolean>,
}

const AlertSettingSwitchers: FC<AlertSettingSwitchersProps> = ({
  alertType,
  isSwitching,
  setIsSwitching,
  isRelative,
  setIsRelative
}) => {
  const {addErrorToast} = useSnackbarHook();
  const {t} = useTranslation('settings');

  const radioGroupValue =
  isRelative ? ProcessAlertRange.RELATIVE : ProcessAlertRange.ABSOLUTE;

  const switchAlertSettings = async (event) => {
    setIsSwitching(true);
    const {checked, value} = event.target;
    const isSwitchedToRelative = value === relativeValue;

    if (checked && isSwitchedToRelative) {
      setIsRelative(true);
    } else {
      setIsRelative(false);
    }

    try {
      await updateAllAlertSettings(alertType, isSwitchedToRelative);
    } catch (error) {
      setIsRelative(!isSwitchedToRelative);
      addErrorToast(error?.message);
    } finally {
      setIsSwitching(false);
    }
  };

  return (
    <div className="switchers">
      <RadioGroup onChange={switchAlertSettings} value={radioGroupValue}>
        <FormControlLabel
          value={ProcessAlertRange.RELATIVE}
          control={<Radio size="small"/>}
          label={<span>{t('alert.switchers.relativeRange')}</span>}
          disabled={isSwitching}
          className="switcher-row"
        />
        <FormControlLabel
          value={ProcessAlertRange.ABSOLUTE}
          control={<Radio size="small"/>}
          disabled={isSwitching}
          className="switcher-row"
          label={
            <span className="range_wrapper">
              <span className="name">{t('alert.switchers.absoluteRange.absolute')}</span>
              <span>{t('alert.switchers.absoluteRange.minSec')}</span>
            </span>
          }
        />
      </RadioGroup>
    </div>
  );
};

export default AlertSettingSwitchers;
